import Image from 'next/image';

import { useWindowSize } from '@/hooks/index';

import Button from '../Button/Button';

import styles from './RightImageBanner.module.scss';

const RightImageBanner = ({ data }) => {
  const [windowsX] = useWindowSize();

  return (
    <section
      className={styles.rightImage_banner__wrapper}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className='wrapper'>
        <div className={styles.content}>
          <span className={styles.label}>{data?.top_text}</span>
          <h2 className={styles.title}>{data?.title}</h2>
          {data?.button_text && (data?.button_slug || data?.external_link) && (
            <Button
              size='shortTrapezoid'
              variant='trapezoidRed'
              href={data?.button_slug ? data?.button_slug : data?.external_link}
              Component={data?.button_slug ? 'router' : 'button'}
              className={styles.btn}
              aria-label={data?.button_text}
            >
              {data?.button_text}
            </Button>
          )}
        </div>
        <div className={styles.rightImage}>
          <Image
            src={windowsX > 767 ? data?.image : data?.mobile_image}
            width={1068}
            height={600}
            objectFit='cover'
            alt='banner right image'
          />
        </div>
      </div>
    </section>
  );
};

export default RightImageBanner;
